import { Download } from "lucide-react";

export default function Footer() {
	const year = new Date().getFullYear();

	const links = {
		Company: [
			{ label: "About Us", href: "#" },
			{ label: "Careers", href: "#" },
			{ label: "Press", href: "#" },
			{ label: "Blog", href: "#" },
		],
		Services: [
			{ label: "Doctor Visit", href: "#" },
			{ label: "Nurse Care", href: "#" },
			{ label: "Lab Tests", href: "#" },
			{ label: "Pharmacy", href: "#" },
		],
		Support: [
			{ label: "Help Center", href: "#" },
			{ label: "Privacy Policy", href: "#" },
			{ label: "Terms of Service", href: "#" },
			{ label: "Contact", href: "#contact" },
		],
	};

	const socials = [
		{
			label: "Facebook",
			href: "https://www.facebook.com/profile.php?id=61585176556676",
			icon: (
				<svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
					<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
				</svg>
			),
		},
		{
			label: "Instagram",
			href: "#",
			icon: (
				<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
					<rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
					<circle cx="12" cy="12" r="4" />
					<circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
				</svg>
			),
		},
		{
			label: "Twitter / X",
			href: "#",
			icon: (
				<svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
					<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
				</svg>
			),
		},
		{
			label: "LinkedIn",
			href: "#",
			icon: (
				<svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
					<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
					<circle cx="4" cy="4" r="2" />
				</svg>
			),
		},
	];

	return (
		<footer id="download" className="bg-gray-900 w-full text-white">
			
			<div className="bg-primary">
				<div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
					<div className="flex flex-col gap-1">
						<h3 className="text-xl font-bold text-white">
							Ready to get started?
						</h3>
						<p className="text-orange-100 text-sm">
							Download Dawi today and connect with top healthcare professionals.
						</p>
					</div>
					<button className="flex items-center gap-2 bg-white text-primary hover:bg-orange-50 transition-colors font-semibold px-6 py-3 rounded-full shadow-md flex-shrink-0">
						<Download size={18} />
						Download Now
					</button>
				</div>
			</div>

			<div className="max-w-6xl mx-auto px-6 py-14 flex flex-col gap-12">
				<div className="flex flex-col md:flex-row gap-12">
					<div className="flex flex-col gap-4 md:w-64 flex-shrink-0">
						<div className="flex flex-col leading-tight">
							<span className="text-2xl font-bold text-white">Dawi</span>
							<span className="text-xs text-gray-400">Healthcare & More</span>
						</div>
						<p className="text-sm text-gray-400 leading-relaxed">
							Egypt’s top multi-vendor health app — book qualified doctors, nurses & caregivers for home visits in seconds.
						</p>
						<div className="flex items-center gap-3">
							{socials.map((social) => (
								<a
									key={social.label}
									href={social.href}
									aria-label={social.label}
									className="w-9 h-9 rounded-full bg-gray-800 hover:bg-primary flex items-center justify-center text-gray-400 hover:text-white transition-colors duration-200"
								>
									{social.icon}
								</a>
							))}
						</div>
					</div>

					<div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8 md:pl-32">
						{Object.entries(links).map(([category, items]) => (
							<div key={category} className="flex flex-col gap-4">
								<span className="text-xs font-semibold uppercase tracking-widest text-gray-500">
									{category}
								</span>
								<ul className="flex flex-col gap-3">
									{items.map((item) => (
										<li key={item.label}>
											<a
												href={item.href}
												className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
											>
												{item.label}
											</a>
										</li>
									))}
								</ul>
							</div>
						))}
					</div>
				</div>

				<div className="border-t border-gray-800 pt-8 flex flex-col items-center gap-2 text-xs text-gray-500">
					<span>© {year} Dawi. All rights reserved.</span>
					<span>Made with ❤️ in Egypt</span>
				</div>
			</div>
		</footer>
	);
}